export default __webpack_public_path__ + "static/media/kinder9.7a859562.jpg";